import { useState, useEffect } from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  HeadTableCell,
  RowTableCell,
  CustomButton,
  ActionIconButton,
} from '../../../common/components';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PeiValueEditDialog from './PeiValueEditDialog';

const PeiValueDialog = ({ open, onClose, legalEntity, selectedPlan }) => {
  const [peiValues, setPeiValues] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedPeiValue, setSelectedPeiValue] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  // Simular carga de valores PEI para la entidad legal
  useEffect(() => {
    if (open && legalEntity) {
      loadPeiValues();
    }
  }, [open, legalEntity]);

  const loadPeiValues = async () => {
    setLoading(true);
    try {
      // Aquí iría la lógica real para cargar los valores PEI
      // Por ahora simulamos algunos datos
      const mockPeiValues = [
        {
          id: 1,
          uuid: 'pei-1',
          fee: { name: 'Cuota Completa' },
          amount: 5,
          rate: 0
        },
        {
          id: 2,
          uuid: 'pei-2',
          fee: { name: 'Cuota Incompleta' },
          amount: 5,
          rate: 0
        },
        {
          id: 3,
          uuid: 'pei-3',
          fee: { name: 'Adecuacion' },
          amount: 0,
          rate: 0
        }
      ];
      setPeiValues(mockPeiValues);
    } catch (error) {
      console.error('Error loading PEI values:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setSelectedPeiValue(null);
    setEditMode(false);
    setEditDialogOpen(true);
  };

  const handleEdit = (peiValue) => {
    setSelectedPeiValue(peiValue);
    setEditMode(true);
    setEditDialogOpen(true);
  };

  const handleDelete = async (uuid) => {
    try {
      // Aquí iría la lógica real para eliminar
      setPeiValues(prev => prev.filter(value => value.uuid !== uuid));
    } catch (error) {
      console.error('Error deleting PEI value:', error);
    }
  };

  const handleSave = async (data) => {
    try {
      if (editMode) {
        // Actualizar existente
        setPeiValues(prev => prev.map(value => 
          value.uuid === selectedPeiValue.uuid 
            ? { ...value, ...data }
            : value
        ));
      } else {
        // Crear nuevo
        const newPeiValue = {
          id: Date.now(),
          uuid: `pei-${Date.now()}`,
          ...data
        };
        setPeiValues(prev => [...prev, newPeiValue]);
      }
      setEditDialogOpen(false);
    } catch (error) {
      console.error('Error saving PEI value:', error);
    }
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setSelectedPeiValue(null);
    setEditMode(false);
  };

  return (
    <>
      <DialogContainer open={open} onClose={onClose} size="large">
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CustomButton variant="contained" onClick={handleAdd}>
              <PostAddIcon sx={{ mr: 1 }} />
              Agregar
            </CustomButton>
            {legalEntity ? legalEntity.legal_business_name : 'Entidad Intermedia'}, tipos de cuota
          </Box>
        </DialogTitle>

        <DialogBody sx={{ p: 2, minHeight: '400px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Tipo Cuota</HeadTableCell>
                <HeadTableCell>Monto</HeadTableCell>
                <HeadTableCell>Porcentaje</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <RowTableCell colSpan={4} sx={{ textAlign: 'center' }}>
                    Cargando...
                  </RowTableCell>
                </TableRow>
              ) : (
                peiValues.map((peiValue, index) => (
                  <TableRow key={peiValue.id || index}>
                    <RowTableCell>{peiValue.fee?.name}</RowTableCell>
                    <RowTableCell>{peiValue.amount}</RowTableCell>
                    <RowTableCell>{peiValue.rate}</RowTableCell>
                    <RowTableCell>
                      <ActionIconButton 
                        variant="edit" 
                        onClick={() => handleEdit(peiValue)} 
                      />
                      <ActionIconButton 
                        variant="delete" 
                        onClick={() => handleDelete(peiValue.uuid)} 
                      />
                    </RowTableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </DialogBody>
      </DialogContainer>

      <PeiValueEditDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        onSave={handleSave}
        selectedItem={selectedPeiValue}
        editMode={editMode}
        legalEntity={legalEntity}
        selectedPlan={selectedPlan}
      />
    </>
  );
};

export default PeiValueDialog;
